import type { MediaAssetV1 } from "@/contracts/media/MediaAssetV1";
import type { TimelineAddDetail } from "@/contracts/media/MediaPanelEvents";

import { OMNICINE_DEV_ASSET_CATALOG as OMNICINE_DEV_ASSET_CATALOG_DATA } from "./omnicineDevAssetCatalog.data";

export type OmniCineDevAssetCatalogEntry = {
  key: string;
  mediaAssetId: string;
  previewAssetId: string;
  kind: MediaAssetV1["kind"];
  label: string;
  durSec: number;
  mediaUrl: string;
  previewTrackId?: string;
  surfaces: Array<"mediaPanel" | "previewShelf">;
  seedTags: string[];
  ingestMetadata?: Partial<TimelineAddDetail>;
};

export const OMNICINE_DEV_ASSET_CATALOG =
  OMNICINE_DEV_ASSET_CATALOG_DATA as unknown as OmniCineDevAssetCatalogEntry[];

export function getOmniCineDevAssetCatalogEntry(assetId: string): OmniCineDevAssetCatalogEntry | null {
  return OMNICINE_DEV_ASSET_CATALOG.find((asset) => asset.mediaAssetId === assetId) ?? null;
}

export function createOmniCineSeedMediaAssets(): MediaAssetV1[] {
  return OMNICINE_DEV_ASSET_CATALOG.map((asset) => ({
    v: 1,
    id: asset.mediaAssetId,
    label: asset.label,
    kind: asset.kind,
    durSec: asset.durSec,
    ref: { v: 1, provider: "static", path: asset.mediaUrl },
    tags: asset.seedTags,
  }));
}
